import { Button, Flex, Text } from '@theme-ui/components'
import { useFormikContext } from 'formik'
import React, { useContext } from 'react'
import useCurrentUserStore from '../../../stores/currentUser'
import { ReportContext, ReportFormValues } from './ReportForm'

export default function ViolationRadio() {
  const { values, setFieldValue, errors } = useFormikContext<ReportFormValues>()
  const { report } = useContext(ReportContext)
  const roles = useCurrentUserStore((state) => state.currentUser.data?.roles)

  if (`${report?.state}_${roles}` !== 'unverified_admin_verificator')
    return null

  return (
    <Flex
      id="isViolation"
      sx={{ alignItems: 'center', flexDirection: 'column', mb: 3 }}
    >
      <Flex sx={{ gap: 2, justifyContent: 'center' }}>
        <Button
          type="button"
          variant={values.isViolation === true ? 'destructive' : 'warning'}
          onClick={() => setFieldValue('isViolation', true)}
        >
          Pelanggaran
        </Button>
        <Button
          type="button"
          variant={values.isViolation === false ? 'destructive' : 'warning'}
          onClick={() => setFieldValue('isViolation', false)}
        >
          Bukan Pelanggaran
        </Button>
      </Flex>
      {errors.isViolation && <Text color="error">{errors.isViolation}</Text>}
    </Flex>
  )
}
